import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as organizationActions from './organization.actions';
import { Injectable } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { ApiService } from '../services/api.service';


@Injectable()
export class OrganizationEffects {

  fetchOrganization = createEffect(() => this.actions$.pipe(
    ofType(organizationActions.fetchOrganizationAction),
    switchMap((action) => {
      return this.api.organizationInfoGetByCode(action.payload);
    }),
    map((context) => {
      // TODO обреботать ошибку загрузки
      // if(context.error){
      //
      // }
      return organizationActions.storeOrganizationAction(
        this.api.convertOrganizationResponseToOrganization(context.result)
      );
    })
  ));


  constructor(
    private actions$: Actions,
    private api: ApiService,
  ) {

  }

}
